module.exports = __webpack_public_path__ + "img/complete.7378320a.png";